import { SxProps, Theme } from '@mui/material';

export const specsSx: Record<string, SxProps<Theme>> = {
	triggerButton: {
		color: 'secondary.main',
		'&:hover': {
			textDecoration: 'underline',
			cursor: 'pointer',
		},
	},
	link: {
		color: 'secondary.main',
		'&:hover': {
			textDecoration: 'underline',
			cursor: 'pointer',
		},
	},
	drawerPaperSx: {
		'.MuiDrawer-paper': {
			width: { md: '100%', lg: 385 },
			maxHeight: { sm: '80vh', lg: '100%' },
			bottom: '60px',
		},
	},
	headerSx: {
		display: 'flex',
		justifyContent: 'space-between',
		p: '15px 20px',
		textAlign: 'left',
	},
	closeButtonSx: {
		color: 'grey.200',
		cursor: 'pointer',
		fontSize: '20px',
		':hover': {
			color: 'primary.main',
		},
	},
	divider: {
		borderColor: 'grey.50',
		my: '10px',
	},
	dividerTitle: {
		borderColor: 'grey.50',
	},
	card: {
		border: '1px solid rgb(204, 204, 204)',
		borderRadius: '5px',
		margin: '10px',
	},
	cardHeader: {
		display: 'flex',
		gap: '10px',
		p: '10px',
	},
	nameContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
	cardBody: {
		p: '10px',
		display: 'flex',
		flexDirection: 'column',
	},
	sku: {
		color: 'grey.300',
		pt: '2px',
	},
	marginTop: {
		mt: '10px',
	},
	contentBox: {
		height: '100%',
		display: 'flex',
		alignItems: 'center',
	},
	attribute: {
		width: '50%',
		padding: '10px',
	},
};
